var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBkgrMenuBt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0129 37.5C75.0129 42.0704 74.1953 46.4498 72.6984 50.5C71.2393 54.4477 66.6348 59.3059 64.0129 62.5C60.0483 67.3299 57.4007 69.9285 51.513 72.2994C47.1873 74.0413 42.4621 75 37.513 75C21.9428 75 11.6827 69.5108 6.01294 56C4.14106 51.5394 0.0129501 42.6405 0.0129501 37.5C0.0129501 30.5662 -0.361727 26.0719 2.91914 20.5C6.44726 14.5082 9.84972 9.75789 16.0129 6.5C21.2372 3.73842 31.1925 0 37.513 0C43.8334 0 49.7887 1.56366 55.013 4.32523C59.4475 6.66935 63.3554 9.8766 66.5129 13.7233C71.8247 20.1943 75.0129 28.4748 75.0129 37.5Z",
    fill: "#DFD4CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgrMenuBt);
export default __webpack_public_path__ + "static/media/BkgrMenuBt.6c38e6002ded9a19df78ac9deea99edc.svg";
export { ForwardRef as ReactComponent };